import { Box, Text, createStyles } from "@mantine/core";

import arrowButton from "../../assets/img/sideArrow.svg";

const useStyles = createStyles(() => ({
  Headingclass: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    color: "#262930",
    marginBottom: "12px",
  },
  subHeadingClass: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#262930",
  },
  flexdisplay: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  details: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "22px",
    color: "#262930",
  },
}));
interface MedicationCardProps {
  heading: string;
  subHeading: string;
  dateDetail:string;
  Details:string
}

export const ClinicalNotescards: React.FC<MedicationCardProps> = ({
  heading,
  subHeading,
  dateDetail,
  Details
}) => {
  const { classes } = useStyles();

  return (
    <Box
      sx={{
        border: "1px solid #EDEDED",
        borderRadius: "4px",
        padding:"12px",
        width:"340px",
        backgroundColor:"white",
         marginBottom: "16px",

      }}
    >
     <Box className={classes.Headingclass}>{heading}</Box>
      <Box className={classes.flexdisplay}>
        <Box className={classes.subHeadingClass}>{subHeading}</Box>
        <Box className={classes.subHeadingClass}>{dateDetail}</Box>
      </Box>
      <Box className={classes.details}>
        {Details}
      </Box>
      
    </Box>
  );
};
